import {http_client} from "@/plugins/http_client";

const getInvitaciones = async(id, params)=> await http_client('/api/v1/invitation/'+ id ,params,'get');

const putInvitacion = async(params) => await http_client(`/api/v1/invitation/${params}`,{},'put')

export default{
    getInvitaciones,
    putInvitacion
}